<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-bottom: 30px;"
      >
        <div class="wrapper-form">
          <!-- INFORMASI PENGURUS -->
          <h3>Data Diri</h3>
          <SizedBox :height="60" />
          <div class="form-group">
            <label for="fullname"
              ><strong>Nama Lengkap</strong></label
            >
            <p>{{ !fullname ? 'Loading...' : fullname }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="email"><strong>Email</strong></label>
            <p>{{ !email ? 'Loading...' : email }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="no_telp"
              ><strong>Nomor Telepon / HP</strong></label
            >
            <p>{{ !no_telp ? 'Loading...' : no_telp }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="jeniskelamin"
              ><strong>Jenis Kelamin</strong></label
            >
            <p>{{ !jeniskelamin ? 'Loading...' : jeniskelamin }}</p>
          </div>

          <SizedBox :height="15" />
          <div class="form-group">
            <label for="tanggallahir"
              ><strong>Tanggal Lahir</strong></label
            >
            <p>{{ !tanggallahir ? 'Loading...' : tanggallahir }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="masjed_address">
              <strong>Tempat Lahir </strong>
            </label>
            <p>{{ !tempat_lahir ? 'Loading...' : tempat_lahir }}</p>
          </div>

          <SizedBox :height="15" />

          <h3>Data Pendukung I</h3>

          <SizedBox :height="60" />

          <div class="form-group">
            <label for="nik"><strong>Foto KTP</strong></label>
            <div class="card">
              <div class="cekrek" v-if="!nik_url">
                <img src="/img/cekrek.png" />
              </div>
              <div id="preview" class="preview">
                <img v-if="nik_url" :src="nik_url" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="nik"
              ><strong>NIK ( Nomor Induk KTP )</strong></label
            >
            <p>{{ !nik ? 'Loading...' : nik }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kk_url"><strong>Foto KK</strong></label>
            <div class="card">
              <div class="cekrek" v-if="!kk_url">
                <img src="/img/cekrek.png" />
              </div>
              <div id="preview" class="preview">
                <img v-if="kk_url" :src="kk_url" />
              </div>
            </div>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="nik"
              ><strong>No KK ( Kartu Keluarga )</strong></label
            >
            <p>{{ !kk ? 'Loading...' : kk }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="nik">
              <strong>Nama Kepala Keluarga ( Tertera di KK )</strong>
            </label>
            <p>
              {{ !kepala_keluarga ? 'Loading...' : kepala_keluarga }}
            </p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="provinsi"><strong>Provinsi</strong></label>
            <p>{{ !provinsi ? 'Loading...' : provinsi }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kota"><strong>Kota</strong></label>
            <p>{{ !kota ? 'Loading...' : kota }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kecamatan"><strong>Kecamatan</strong></label>
            <p>{{ !kecamatan ? 'Loading...' : kecamatan }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <p>{{ !alamat ? 'Loading...' : alamat }}</p>
          </div>

          <h3>Data Pendukung II</h3>

          <SizedBox :height="60" />

          <div class="form-group">
            <label for="pendidikan_terakhir">
              <strong>Pendidikan Terakhir</strong>
            </label>
            <p>
              {{
                !pendidikan_terakhir
                  ? 'Loading...'
                  : pendidikan_terakhir
              }}
            </p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kejuruan">
              <strong>Kejuruan</strong>
            </label>
            <p>{{ !kejuruan ? 'Loading...' : kejuruan }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="gelar_akademis">
              <strong>Gelar Akademis</strong>
            </label>
            <p>
              {{ !gelar_akademis ? 'Loading...' : gelar_akademis }}
            </p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kejuruan">
              <strong>
                Apakah anda berfaham Ahlusunnah Wal Jamaah
              </strong>
            </label>
            <div style="display:flex;">
              <p>{{ !faham ? 'Loading...' : faham }}</p>
            </div>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="kepakaran">
              <strong>Kepakaran</strong>
            </label>
            <p>{{ !kepakaran ? 'Loading...' : kepakaran }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="materi_andalan">
              <strong>Materi Andalan yang dibawakan</strong>
            </label>
            <p>
              {{ !materi_andalan ? 'Loading...' : materi_andalan }}
            </p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="organisasi">
              <strong>Organisasi masyarakat yang diikuti</strong>
            </label>
            <p>{{ !organisasi ? 'Loading...' : organisasi }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="pekerjaan">
              <strong>Pekerjaan</strong>
            </label>
            <p>{{ !pekerjaan ? 'Loading...' : pekerjaan }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="alamat_kerja">
              <strong>Alamat Kerja</strong>
            </label>
            <p>{{ !alamat_kerja ? 'Loading...' : alamat_kerja }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="majelis">
              <strong>Masjed / Majelis</strong>
            </label>
            <p>{{ !majelis ? 'Loading...' : majelis }}</p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="lembaga_pribadi">
              <strong>
                Apakah anda memiliki lembaga yang dikelola pribadi?
              </strong>
            </label>
            <br /><br />
            <div>
              <ol
                class="lembaga_pribadi"
                v-if="lembaga_pribadi.length > 0"
              >
                <li
                  v-for="(lembaga, index) in lembaga_pribadi"
                  :key="index"
                >
                  {{ lembaga }}
                </li>
              </ol>
              <div v-else>( Kosong )</div>
            </div>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="majelis">
              <strong>Kewarganegaraan</strong>
            </label>

            <p>
              {{ !kewarganegaraan ? 'Loading...' : kewarganegaraan }}
            </p>
          </div>

          <SizedBox :height="15" />

          <div class="form-group">
            <label for="majelis">
              <strong>Status Pernikahan</strong>
            </label>
            <div style="display:flex;">
              <p>
                {{
                  !status_pernikahan
                    ? 'Loading...'
                    : status_pernikahan
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/FixedTopbar.vue';
import SizedBox from '@/components/SizedBox.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';
import axios from '@/utils/masjedapi';

export default {
  name: 'donation-detail',
  components: {
    TopBar,
    SizedBox,
    DatePicker,
    Select2,
  },
  data() {
    return {
      isSubmit: false,

      id: '',

      fullname: '',
      email: '',
      no_telp: '',
      tanggallahir: '',
      jeniskelamin: '',
      agama: '',
      provinsi: '',
      kota: '',
      kecamatan: '',
      alamat: '',
      tempat_lahir: '',
      kepala_keluarga: '',

      pendidikan_terakhir: '',
      kejuruan: '',
      gelar_akademis: '',

      faham: '',
      kepakaran: '',
      pekerjaan: '',
      organisasi: '',
      alamat_kerja: '',
      majelis: '',
      lembaga_pribadi: [],
      kewarganegaraan: '',
      status_pernikahan: '',

      materi_andalan: '',

      nik: '',
      nik_url: null,
      nik_file: null,

      kk: '',
      kk_url: null,
      kk_file: null,

      // Maps
      center: { lat: 45.508, lng: -73.587 },
      zoom: 17,
      markers: [],
      currentPlace: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },

      reff_code: '',

      // hostImage: "http://localhost:8000",
      hostImage: 'https://api.masjed.id',
    };
  },
  mounted() {
    window.scrollTo(0, 0);

    this.reff_code = this.$route.params.ref_code;
    this.id = this.$route.params.id;

    this.fetchOne();
  },
  methods: {
    backToGate() {
      this.$router.push({
        name: 'akusisi-user-report-relawan',
        params: { ref_code: this.reff_code },
      });
    },
    fetchOne() {
      const self = this;
      axios.get(`/akusisi/ustad/${this.id}`).then((response) => {
        const { data } = response.data;
        console.log(data);

        self.fullname = data.fullname;
        self.email = data.email;
        self.no_telp = data.no_hp;
        self.tanggallahir = data.tgl_lahir;
        self.jeniskelamin =
          data.jenis_kelamin == 'L' ? 'Laki-laki' : 'Perempuan';
        self.agama = '';
        self.provinsi = data.provinsi
          ? data.provinsi.name
          : '( kosong )';
        self.kota = data.kota ? data.kota.name : '( kosong )';
        self.kecamatan = data.kecamatan
          ? data.kecamatan.name
          : '( kosong )';
        self.alamat = data.alamat || '( kosong )';
        self.tempat_lahir = data.tempat_lahir;
        self.kepala_keluarga = data.keluarga
          ? data.keluarga.nama_kepala_keluarga
          : '( kosong )';

        self.pendidikan_terakhir = data.pendidikan
          ? data.pendidikan.nama_pendidikan
          : '( kosong )';
        self.kejuruan = data.jurusan || '( kosong )';
        self.gelar_akademis = data.gelar_akademis || '( kosong )';
        self.pekerjaan = data.pekerjaan
          ? data.pekerjaan.nama_pekerjaan
          : '( kosong )';
        self.alamat_kerja = data.pekerjaan
          ? data.pekerjaan.alamat_tempat_kerja
          : '( kosong )';
        self.faham = data.informasi
          ? data.informasi[3].konten
          : '( kosong )';

        self.status_pernikahan = '( Kosong )';
        self.organisasi = '( Kosong )';
        self.materi_andalan = '( Kosong )';
        self.faham = '( Kosong )';
        self.kepakaran = '( Kosong )';
        self.majelis = '( Kosong )';
        self.lembaga_pribadi = [];
        self.kewarganegaraan = '( Kosong )';

        if (data.informasi) {
          data.informasi.map((item) => {
            if (item.jenis == 'marital_status') {
              self.status_pernikahan =
                item.konten == 'married'
                  ? 'Menikah'
                  : 'Belum Menikah';
            }
            if (item.jenis == 'ormas') {
              self.organisasi = item.konten;
            }
            if (item.jenis == 'materi_andalan') {
              self.materi_andalan = item.konten;
            }
            if (item.jenis == 'ahlusunah') {
              self.faham = item.konten;
            }
            if (item.jenis == 'kepakaran') {
              self.kepakaran = item.konten;
            }
            if (item.jenis == 'masjid_kajian') {
              self.majelis = item.konten;
            }
            if (item.jenis == 'kewarganegaraan') {
              self.kewarganegaraan = item.konten;
            }
            if (item.jenis == 'lembaga_pribadi') {
              self.lembaga_pribadi.push(item.konten);
            }
          });
        }

        self.nik = data.no_ktp ? data.no_ktp : '( kosong )';
        self.nik_url = data.ktp
          ? `${self.hostImage}${data.ktp.path}`
          : '';

        self.kk = data.keluarga
          ? data.keluarga.no_kk !== null
            ? data.keluarga.no_kk
            : '( kosong )'
          : '( kosong )';
        self.kk_url = data.kk
          ? `${self.hostImage}${data.kk.path}`
          : '';
      });
    },
  },
  directives: {
    numberOnly: {
      bind: function(el) {
        el.handler = function() {
          el.value = el.value.replace(/\D+/, '');
        };
        el.addEventListener('input', el.handler);
      },
      unbind: function(el) {
        el.removeEventListener('input', el.handler);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.wrapper-form {
  position: relative;
  h3 {
    position: absolute;
    font-size: 17px;
    margin: 0px;
    left: -15px;
    background: transparent
      linear-gradient(180deg, #28a745 0%, #145423 100%) 0% 0%
      no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}

.error {
  font-size: 11px;
  color: rgb(255, 13, 13);
}

.lembaga_pribadi {
  margin: 0px;
  padding: 0px;
  margin-left: 20px;
}
</style>
